import { useState } from "react";
import { Button, Form, Input, InputNumber, Space } from "antd";
import { useTranslation } from "react-i18next";
import ApiService from "../../../../../core/service/api-service";

export default function CertificateDownloadModal({ hospitalId, pacsSystemId, onSuccess }) {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const handleDownload = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);

            const response = await ApiService.PacsSystem.GenerateClientCertificate(hospitalId, pacsSystemId, {
                ipAddress: values.ipAddress,
                userInfo: values.userInfo,
                validityDays: values.validityDays
            });

            if (response.success && response.data) {
                // Create download link from blob URL
                const link = document.createElement('a');
                link.href = response.data;
                link.download = response.fileName || `client-certificate-${values.ipAddress.replace(/\./g, '-')}.zip`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                onSuccess && onSuccess();
            }
        } catch (error) {
            console.error('Certificate generation failed:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Form
            form={form}
            layout="vertical"
            initialValues={{
                validityDays: 30
            }}
        >
            <Form.Item
                name="ipAddress"
                label={t('IP Address')}
                rules={[
                    { required: true, message: t('Please enter IP address') },
                    {
                        pattern: /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
                        message: t('Please enter a valid IP address')
                    }
                ]}
            >
                <Input placeholder="192.168.1.100" />
            </Form.Item>

            <Form.Item
                name="userInfo"
                label={t('User Info')}
                rules={[{ required: true, message: t('Please enter user info') }]}
            >
                <Input placeholder={t('Enter user identifier')} />
            </Form.Item>

            <Form.Item
                name="validityDays"
                label={t('Validity Days')}
                rules={[
                    { required: true, message: t('Please enter validity days') },
                    { type: 'number', min: 1, max: 3650, message: t('Validity must be between 1 and 3650 days') }
                ]}
            >
                <InputNumber min={1} max={3650} style={{ width: '100%' }} />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
                <Button
                    type="primary"
                    onClick={handleDownload}
                    loading={loading}
                >
                    {t('Download Certificate')}
                </Button>
            </Form.Item>
        </Form>
    );
}
